module.exports = __webpack_public_path__ + "img/teamAnalysis.5a5b73ee.svg";